import React, { Component } from 'react'
import ZoomControl from './ZoomControl'

import '../scss/ZoomControlContainer.scss'


class ZoomControlContainer extends Component {
  
  constructor (props) {
    super(props)
    this.state = {
      display: false,
      mouseOver: false
    }
  }
  
  shouldDisplay () {
    return this.props.display || this.state.display
  }
  
  componentDidUpdate (prevProps, prevState) {
    if (this.props.scale !== prevProps.scale && !this.state.mouseOver) {
      this.setState({
        display: true
      })
      
      clearTimeout(this.displayTimeout)
      
      this.displayTimeout = setTimeout(() => {
        this.setState({
          display: false
        })
      }, 2000)
    }
  }

  render () {
    return (
      <div className="ZoomControlContainer" data-display={this.shouldDisplay()}>
        <ZoomControl {...this.props} />
      </div>
    )
  }
}

export default ZoomControlContainer
